"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DECLENSION_OPTIONS = void 0;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var BASE_PATTERNS = {
  der: ['der', 'die', 'das', 'den', 'dem', 'des'],
  ein: ['ein', 'eine', 'einen', 'einem', 'einer', 'eines'],
  kein: ['kein', 'keine', 'keinen', 'keinem', 'keiner', 'keines'],
  mein: ['mein', 'meine', 'meinen', 'meinem', 'meiner', 'meines', 'meins'],
  dein: ['dein', 'deine', 'deinen', 'deinem', 'deiner', 'deines', 'deins'],
  sein: ['sein', 'seine', 'seinen', 'seinem', 'seiner', 'seines', 'seins'],
  ihr: ['ihr', 'ihre', 'ihren', 'ihrem', 'ihrer', 'ihres'],
  unser: ['unser', 'unsere', 'unseren', 'unserem', 'unserer', 'unseres'],
  euer: ['euer', 'eure', 'euren', 'eurem', 'eurer', 'eures'],
  Ihr: ['Ihr', 'Ihre', 'Ihren', 'Ihrem', 'Ihrer', 'Ihres'],
  dieser: ['dieser', 'diese', 'dieses', 'diesen', 'diesem', 'dies'],
  jener: ['jener', 'jene', 'jenes', 'jenen', 'jenem'],
  derjenige: ['derjenige', 'diejenige', 'dasjenige', 'denjenigen', 'demjenigen', 'diejenigen'],
  derselbe: ['derselbe', 'dieselbe', 'dasselbe', 'denselben', 'demselben'],
  welcher: ['welcher', 'welche', 'welches', 'welchen', 'welchem', 'welch'],
  wer: ['wer', 'wen', 'wem', 'wessen'],
  jeder: ['jeder', 'jede', 'jedes', 'jeden', 'jedem'],
  alle: ['alle', 'alles', 'allen', 'aller', 'allem'],
  einige: ['einige', 'einigen', 'einiger', 'einigem', 'einiges'],
  mehrere: ['mehrere', 'mehreren', 'mehrerer', 'mehrerem', 'mehreres'],
  manche: ['manche', 'mancher', 'manches', 'manchen', 'manchem', 'manch'],
  beide: ['beide', 'beiden', 'beides', 'beider'],
  viel: ['viel', 'viele', 'vielen', 'vieler', 'vielem'],
  wenig: ['wenig', 'wenige', 'wenigen', 'weniger'],
  andere: ['andere', 'anderes', 'anderen', 'anderem', 'anderer'],
  solche: ['solche', 'solcher', 'solches', 'solchen', 'solchem', 'solch'],
  sämtliche: ['sämtliche', 'sämtlicher', 'sämtlichen', 'sämtlichem'],
  jegliche: ['jegliche', 'jeglicher', 'jegliches', 'jeglichen', 'jeglichem'],
  ich: ['ich', 'mich', 'mir', 'meiner'],
  du: ['du', 'dich', 'dir', 'deiner'],
  er: ['er', 'ihn', 'ihm', 'seiner'],
  sie: ['sie', 'ihr', 'ihrer', 'ihn'],
  es: ['es', 'ihm', 'seiner', 'ihn'],
  wir: ['wir', 'uns', 'unser', 'unsere'],
  Sie: ['Sie', 'Ihnen', 'Ihrer', 'seiner'],
  sich: ['sich', 'seiner', 'ihrer', 'ihn'],
  irgendein: ['irgendein', 'irgendeine', 'irgendeinen', 'irgendeinem', 'irgendeiner', 'irgendeines'],
  irgendwelch: ['irgendwelch', 'irgendwelche', 'irgendwelchen', 'irgendwelchem', 'irgendwelcher'],
  jemand: ['jemand', 'jemanden', 'jemandem', 'jemandes'],
  niemand: ['niemand', 'niemanden', 'niemandem', 'niemandes']
};
var buildDeclensionOptions = function buildDeclensionOptions() {
  var options = {};
  Object.entries(BASE_PATTERNS).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      patternKey = _ref2[0],
      forms = _ref2[1];
    forms.forEach(function (form) {
      options[form] = forms;
    });
  });
  return options;
};
var DECLENSION_OPTIONS = exports.DECLENSION_OPTIONS = buildDeclensionOptions();